import { z } from 'zod'
import type { CatalogApplication } from '#/domain/catalog/CatalogApplication'

export const CatalogApplicationDtoSchema = z
  .object({
    Id: z.string(),
    DisplayName: z.string(),
  })
  .transform((raw): CatalogApplication => ({
    Id: raw.Id,
    DisplayName: raw.DisplayName,
  }))

export type CatalogApplicationResponseDto = z.input<typeof CatalogApplicationDtoSchema>

export function toDomain(raw: CatalogApplicationResponseDto): CatalogApplication {
  return CatalogApplicationDtoSchema.parse(raw)
}

export function toDomainList(raw: CatalogApplicationResponseDto[]): CatalogApplication[] {
  return raw.map(toDomain)
}
